import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CheckIcon from '@material-ui/icons/Check';
import { SI_MENU_PAGESTATES } from 'src/constants/constants';

export default function MenuPres({ menu, changeMenuPage, currentMenuPage, isNextDisabled }) {
  const currentPage = menu[currentMenuPage];

  return (
    <section className="ssi-menu">
      {menu.map((menuItem, index) => (
        <div
          key={menuItem.menuName + index}
          className={classNames({
            'ssi-menuitem': true,
            selected: menuItem === currentPage,
            disabled: isNextDisabled && index > currentMenuPage,
          })}
          onClick={changeMenuPage.bind(null, menuItem.viewType, index)}>
          <label>{menuItem.menuName}</label>
          <div className="ssi-menuitem-circle">
            {(menuItem.pageState === SI_MENU_PAGESTATES.COMPLETE || menuItem.pageState === SI_MENU_PAGESTATES.CURRENT_COMPLETE) && (
              <CheckIcon className="status-complete" />
            )}
          </div>
        </div>
      ))}
    </section>
  );
}

MenuPres.propTypes = {
  menu: PropTypes.array.isRequired,
  changeMenuPage: PropTypes.func.isRequired,
  currentMenuPage: PropTypes.number.isRequired,
  isNextDisabled: PropTypes.bool.isRequired,
};
